import React from "react";

export default function NominalLedgerView({ data, preview_url }) {
  if (!data) return null;

  const header = data || {};

  return (
    <>
      <br />

      {/* Header */}
      <div className="w-full p-3 bg-[#5a6db3]  font-semibold">
        Nominal Ledger Details
      </div>

      {/* Summary */}
      <div className="p-4 bg-white border rounded shadow grid grid-cols-2 gap-6">
        <div>
          <p><b>Client Name:</b> {header.client_name || "-"}</p>
          <p><b>Company Name:</b> {header.company_name || "-"}</p>
          <p><b>File Name:</b> {header.filename || "-"}</p>
        </div>

        <div>
          <p><b>Period Date:</b> {header.period_date || "-"}</p>
          <p><b>Uploaded At:</b> {header.upload_date || "-"}</p>
        </div>
      </div>

      {/* Ledger Entries */}
      {Array.isArray(data.entries) && data.entries.length > 0 && (
        <div className="mt-6 bg-white shadow border">
          <h3 className="p-3 bg-[#5a6db3]  font-semibold">
            Ledger Entries
          </h3>

          <div className="overflow-x-auto">
            <table className="w-full border">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-3 py-2 border">Date</th>
                  <th className="px-3 py-2 border">Code</th>
                  <th className="px-3 py-2 border">Name</th>
                  <th className="px-3 py-2 border">Description</th>
                  <th className="px-3 py-2 border">Debit</th>
                  <th className="px-3 py-2 border">Credit</th>
                  <th className="px-3 py-2 border">Balance</th>
                  <th className="px-3 py-2 border">Reference</th>
                </tr>
              </thead>

              <tbody>
                {data.entries.map((row, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-3 py-2 border">{row.date}</td>
                    <td className="px-3 py-2 border">{row.nominal_code}</td>
                    <td className="px-3 py-2 border">{row.nominal_name}</td>
                    <td className="px-3 py-2 border">{row.description}</td>
                    <td className="px-3 py-2 border text-right">{row.debit}</td>
                    <td className="px-3 py-2 border text-right">{row.credit}</td>
                    <td className="px-3 py-2 border text-right">{row.balance}</td>
                    <td className="px-3 py-2 border">{row.reference}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* PDF Preview */}
      {preview_url && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">
            Uploaded Document Preview
          </h3>
          <iframe
            src={preview_url}
            width="100%"
            height="600"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            title="PDF Preview"
          />
        </div>
      )}
    </>
  );
}
